import { FormContainer } from "@/components/form/FormContainer";
import { usePoolCapacityConfig } from "@/hooks/config/pool/usePoolCapacityConfig";
import { usePoolHadoopConfig } from "@/hooks/config/pool/usePoolHadoopConfig";
import { usePoolMySqlConfig } from "@/hooks/config/pool/usePoolMySqlConfig";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useResourceUpdate } from "@/hooks/useResourceUpdate";
import { UpdateWrapper } from "@/layouts/UpdateWrapper";
import { Button, Space } from "antd";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

export const PoolEditor = () => {
  const {action, id} = useParams();
  const { t } = useTranslation();
  const formRef = useRef();
  const navigate = useResourceNavigate();
  const navigateBack = useNavigate();
  const { mutate } = useResourceUpdate();

  const { isLoading: capacityLoading, isSaving: capacitySaving, value: capacityValue, schema: capacitySchema, save: saveCapacity } = usePoolCapacityConfig(action === 'changeCapacity' ? id : null);
  const { isLoading: mysqlLoading, isSaving: mysqlSaving, value: mysqlValue, schema: mysqlSchema, save: saveMySQL } = usePoolMySqlConfig(action === 'changeMySQL' ? id : null);
  const { isLoading: hadoopLoading, isSaving: hadoopSaving, value: hadoopValue, schema: hadoopSchema, save: saveHadoop } = usePoolHadoopConfig(action === 'changeHadoop' ? id : null);

  let rawValue = {};
  let rawSchema = [];
  let loading = true;
  let doSave = null;
  let saving = false;

  if (action === 'changeCapacity') {
    rawSchema = capacitySchema;
    rawValue = capacityValue;
    loading = capacityLoading;
    saving = capacitySaving;
    doSave = saveCapacity;
  } else if (action === 'changeMySQL') {
    rawSchema = mysqlSchema;
    rawValue = mysqlValue;
    loading = mysqlLoading;
    saving = mysqlSaving;
    doSave = saveMySQL;
  } else if (action === 'changeHadoop') {
    rawSchema = hadoopSchema;
    rawValue = hadoopValue;
    loading = hadoopLoading;
    saving = hadoopSaving;
    doSave = saveHadoop;
  }

  const doCommit = async (values) => {
    const updatedItem = await doSave(values);
    if (updatedItem) {
      if (window.history.length > 1) {
        navigateBack(-1);
      } else {
        navigate({ resource: "pools", action: "list" });
      }
    } else {
      // TODO: show error message
    }
  };
  return (
    <UpdateWrapper
    footer={
      <Space>
        <Button onClick={() => {
          navigate({ resource: "pools", action: "list" });
        }}>Cancel</Button>
        <Button loading={saving} type="primary" onClick={() => formRef.current.submit()}>Save</Button>
      </Space>
    }
    >
      { loading && <div>Loading...</div> }
      { !loading &&
        <FormContainer
          formRef={formRef}
          initValue={rawValue}
          schema={rawSchema}
          onFinishCallback={doCommit}
          style={{ paddingTop: 24 }}
        />
      }
    </UpdateWrapper>
  );
};